import React, { useEffect, useCallback, memo } from "react";

import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  MainButton,
  H3,
  P1,
  Flexbox,
  CustomerSucessController
} from "@talentbait/shared-components";
import { hasErrors } from "../model";

export const StyledDraftCampaignStepLayout = styled(Flexbox)`
  .step-content {
    min-height: 280px;
  }

  b {
    font-weight: bold;
  }
`;

const SKIP_TEMPORARY_DISABLED = true;

const DraftCampaignStepLayout = ({
  header,
  subHeader,
  children,
  onSubmit,
  onSkip,
  loading,
  errors,
  first,
  last,
  info,
  continueText,
  namespace,
  ...rest
}) => {
  const { t } = useTranslation();

  const _onSkip = useCallback(
    (...args) => {
      CustomerSucessController.send(`${namespace}:skip`);
      onSkip(...args);
    },
    [onSkip, namespace]
  );

  useEffect(() => {
    CustomerSucessController.send(`${namespace}:visit`);
  }, [namespace]);

  return (
    <StyledDraftCampaignStepLayout {...rest} gap={24} justifyContent="flex-start">
      <Flexbox gap={24} className="step-content" justifyContent="flex-start">
        <Flexbox gap={8}>
          <H3>{header}</H3>
          {subHeader && <P1>{subHeader}</P1>}
        </Flexbox>

        {children && (
          <Flexbox gap={12} justifyContent="center">
            {children}
          </Flexbox>
        )}
      </Flexbox>
      <Flexbox gap={12} row className="step-buttons">
        {first && !SKIP_TEMPORARY_DISABLED && (
          <MainButton
            onClick={onSkip}
            text={t("Skip Onboarding")}
            variant="text"
            size="large"
            width="full"
            loading={loading}
          />
        )}
        <MainButton
          onClick={onSubmit}
          text={continueText ?? (last ? t("Save latest draft") : t("Continue"))}
          variant="primary"
          size="large"
          width="full"
          loading={loading}
          disabled={hasErrors(errors)}
        />
      </Flexbox>
      <Flexbox gap={16}>{info}</Flexbox>
    </StyledDraftCampaignStepLayout>
  );
};

export default memo(DraftCampaignStepLayout);
